import React from 'react';
import config from '../config';
import './Footer.css';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-main">
        <div className="footer-brand">
          <span className="footer-logo">🦋</span>
          <div>
            <p className="footer-app-name">{config.APP_NAME}</p>
            <p className="footer-tagline">
              Designed with ♥ for children with learning differences
            </p>
          </div>
        </div>

        <div className="footer-legal-cols">
          <div className="footer-legal-block">
            <h4>Educational Use</h4>
            <p>
              All content and activities are designed exclusively for educational purposes and
              are administrator-controlled to ensure age-appropriate material. The platform
              contains no advertisements and no external links accessible to students.
            </p>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          &copy; {year} {config.APP_NAME}. All rights reserved.
        </p>
        <p className="footer-disclaimer">
          {config.APP_NAME} is an independent educational platform. All trademarks and
          intellectual property belong to their respective owners. Unauthorized reproduction
          or distribution of any content is prohibited.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
